module.exports = __webpack_public_path__ + "static/media/cocina.bcfa8d79.jpg";